// File: js/lang.js

export const dict = {
    en: {
        // Top HUD
        brand: "Warehouse_management_system Demo @Pavel Švec",
        statusSync: "SYNCHRONIZING...",
        statusOnline: "ONLINE",
        statusOffline: "OFFLINE (ERROR)",
        statusCalc: "CALCULATING...",
        tempLabel: "TEMP",
        
        // Control Bar (index.html)
        filterAisle: "AISLE",
        allAisles: "ALL",
        findPart: "FIND PART",
        typeSearch: "Type to search...",
        filterTime: "TIMEFRAME",
        time24h: "Last 24 Hours",
        time7d: "Last 7 Days",
        timeAll: "All Time",
        btnHeatmap: "HEATMAP",
        btnStandard: "STANDARD VIEW",
        btnReset: "RESET CAMERA",
        btnKpi: "KPI DASHBOARD",
        
        // Slot Info Panel
        siStatus: "STATUS",
        siInventory: "INVENTORY",

        // KPI Dashboard
        kpiTitle: "WMS | KPI Dashboard",
        kpiBack: "Back to 3D Map",
        kpiSyncing: "Fetching Data...",
        kpiOnline: "Live Sync OK",
        kpiOffline: "API Offline",
        kpiUtil: "Warehouse Utilization",
        kpiOps: "Operations Today",
        kpiOpsSub: "Scans & Moves",
        kpiEmpty: "Empty Slots",
        kpiEmptySub: "Available for Putaway",
        kpiBlocked: "Blocked / Error",
        kpiBlockedSub: "Require Maintenance",
        kpiHighRunners: "High Runners (Top Parts)",
        kpiPartNumber: "Part Number",
        kpiMoves: "Moves",
        kpiStream: "Live Activity Stream",
        kpiTime: "Time",
        kpiEvent: "Event",
        kpiLoc: "Location",
        kpiQty: "Qty",

        // Legend
        legTitle: "Heatmap Legend",
        legTop1: "Top 1% (Outlier)",
        legTop10: "Top 10% (High Runner)",
        legTop25: "Top 25% (Active)",
        legTop50: "Top 50% (Average)",
        legBottom: "Bottom 50% (Low Runner)",
        legConfig: "Configuration",
        legHideLow: "Hide Low Runners",

        // Zone Landing
        zoneLoading: "LOADING DOCK (SEG 1)",
        zoneProd: "PRODUCTION (SEG 8)",

        // Historie, btn
        btnHistory: "View History",
        histTitle: "Slot History",
        histTotal: "Total Moves",
        histEmpty: "Times Emptied",


        // KPI further
        kpiDwell: "Avg. Dwell Time",
        kpiDwellSub: "Hours in Position",
        kpiPickProd: "Picking Productivity",
        kpiOperator: "Operator / Machine",
        kpiPicks: "Completed Picks",

        kpiActiveOps: "Active Operators",
        kpiActiveOpsSub: "Last 24 hours",
        histDwell: "Current Dwell Time",
        histDwellSub: "Hours since putaway",
        histFreq: "Top Assigned Part",
        histFreqSub: "Historical affinity"
    },
    cz: {
        // Top HUD
        brand: "Warehouse_management_system Demo @Pavel Švec",
        statusSync: "SYNCHRONIZACE...",
        statusOnline: "ONLINE",
        statusOffline: "OFFLINE (CHYBA)",
        statusCalc: "POČÍTÁM...",
        tempLabel: "TEPLOTA",
        
        // Control Bar (index.html)
        filterAisle: "ULIČKA",
        allAisles: "VŠE",
        findPart: "HLEDAT DÍL",
        typeSearch: "Pište pro hledání...",
        filterTime: "OBDOBÍ",
        time24h: "Posledních 24 hod",
        time7d: "Posledních 7 dní",
        timeAll: "Celá historie",
        btnHeatmap: "TEPLOTNÍ MAPA",
        btnStandard: "STANDARDNÍ POHLED",
        btnReset: "RESET KAMERA",
        btnKpi: "KPI NÁSTĚNKA",
        
        // Slot Info Panel
        siStatus: "STAV",
        siInventory: "INVENTÁŘ",

        // KPI Dashboard
        kpiTitle: "WMS | KPI Nástěnka",
        kpiBack: "Zpět na 3D mapu",
        kpiSyncing: "Načítání dat...",
        kpiOnline: "Živá synch. OK",
        kpiOffline: "API Odpojeno",
        kpiUtil: "Využití skladu",
        kpiOps: "Dnešní operace",
        kpiOpsSub: "Skeny a přesuny",
        kpiEmpty: "Volné pozice",
        kpiEmptySub: "Dostupné k naskladnění",
        kpiBlocked: "Blokováno / Chyba",
        kpiBlockedSub: "Vyžaduje údržbu",
        kpiHighRunners: "Nejčastější položky",
        kpiPartNumber: "Číslo dílu",
        kpiMoves: "Pohyby",
        kpiStream: "Živý přehled aktivit",
        kpiTime: "Čas",
        kpiEvent: "Událost",
        kpiLoc: "Pozice",
        kpiQty: "Množ.",

        // Legend
        legTitle: "Legenda teplotní mapy",
        legTop1: "Top 1% (Extrém)",
        legTop10: "Top 10% (Velmi časté)",
        legTop25: "Top 25% (Aktivní)",
        legTop50: "Top 50% (Průměr)",
        legBottom: "Spodních 50% (Málo časté)",
        legConfig: "Nastavení",
        legHideLow: "Skrýt málo časté",

        // Zone landing
        zoneLoading: "Nákladní plošina (SEG 1)",
        zoneProd: "Produkční linka (SEG 8)",


        // Historie, button
        btnHistory: "Zobrazit historii",
        histTitle: "Historie pozice",
        histTotal: "Celkem pohybů",
        histEmpty: "Počet vyprázdnění",

        // KPI further
        kpiDwell: "Prům. doba uskladnění",
        kpiDwellSub: "Hodin na pozici",
        kpiPickProd: "Produktivita vychystávání",
        kpiOperator: "Operátor / Stroj",
        kpiPicks: "Dokončené vychystání",

        kpiActiveOps: "Aktivní operátoři",
        kpiActiveOpsSub: "Za posledních 24 hod",
        histDwell: "Doba uskladnění",
        histDwellSub: "Hodin na pozici",
        histFreq: "Nejčastější díl",
        histFreqSub: "Historická afinita"

    }
};

export let currentLang = localStorage.getItem('wms_lang') || 'cz';

export function t(key) {
    return dict[currentLang][key] || key;
}

export function applyTranslations() {
    document.querySelectorAll('[data-i18n]').forEach(el => {
        const key = el.getAttribute('data-i18n');
        if (dict[currentLang][key]) {
            if (el.tagName === 'INPUT' && el.type === 'text') {
                el.placeholder = dict[currentLang][key]; 
            } else {
                el.innerHTML = dict[currentLang][key]; 
            }
        }
    });
}

export function setLanguage(langCode) {
    if (dict[langCode]) {
        currentLang = langCode;
        localStorage.setItem('wms_lang', langCode);
        applyTranslations();
        window.dispatchEvent(new Event('languageChanged'));
    }
}